var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-decoration-underline pa-2",attrs:{"light":"","elevation":"0"}},[_c('v-img',{attrs:{"width":"72","src":require('@/assets/logo.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }